<template>
  <div>
    <v-tabs v-model="tab" background-color="transparent" class="mb-4">
      <v-tab>Jobs</v-tab>
      <v-tab>Failed Jobs</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-row>
          <v-col>
            <app-pagination @click="selectJobs($event)" :data="jobsReport">
              <br />
              <v-data-table dense :headers="jobsHeaders" :items="jobsReport.data" :items-per-page="-1"
                hide-default-footer disable-sort @click:row="viewJob('Job Completo', $event)">
                <template v-slot:item.job="{ item }">
                  {{ getJobName(item.payload) }}
                </template>

                <template v-slot:item.reserved_at="{ item }">
                  {{ formatUnixTimestamp(item.reserved_at) }}
                </template>

                <template v-slot:item.available_at="{ item }">
                  {{ formatUnixTimestamp(item.available_at) }}
                </template>

                <template v-slot:item.created_at="{ item }">
                  {{ formatUnixTimestamp(item.created_at) }}
                </template>



                <template v-slot:item.actions="{ item }">
                  <v-btn x-small text color="primary" @click.stop="viewJob('Job Completo', item)">
                    Ver completo
                  </v-btn>
                </template>
              </v-data-table>
            </app-pagination>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col>
            <app-pagination @click="selectFailedJobs($event)" :data="failedJobsReport">
              <br />
              <v-data-table dense :headers="failedJobsHeaders" :items="failedJobsReport.data" :items-per-page="-1"
                hide-default-footer disable-sort @click:row="viewJob('Failed Job Completo', $event)">
                <template v-slot:item.job="{ item }">
                  {{ getJobName(item.payload) }}
                </template>

                <template v-slot:item.exception="{ item }">
                  <div class="d-flex align-center" style="max-width: 420px; gap: 8px">
                    <span class="text-truncate d-inline-block" style="max-width: 320px">
                      {{ item.exception }}
                    </span>

                  </div>
                </template>



                <template v-slot:item.actions="{ item }">
                  <v-btn x-small text color="primary" @click.stop="viewJob('Failed Job Completo', item)">
                    Ver completo
                  </v-btn>
                </template>
              </v-data-table>
            </app-pagination>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <JobsViewDialog ref="JobsViewDialog" />
  </div>
</template>

<script>
import JobsViewDialog from "@/components/admin/sections/JobsViewDialog.vue";

export default {
  components: { JobsViewDialog },

  data() {
    return {
      tab: 0,
      jobsReport: {
        data: [],
        total: 0,
      },
      failedJobsReport: {
        data: [],
        total: 0,
      },
      jobsHeaders: [
        { text: "Job", value: "job", align: "start" },
        { text: "Tentativas", value: "attempts", align: "end" },
        { text: "Reservado em", value: "reserved_at", align: "start" },
        { text: "Disponível em", value: "available_at", align: "start" },
        { text: "Criado em", value: "created_at", align: "start" },
        { text: "Payload", value: "payload", align: "start" },
        { text: "Ações", value: "actions", align: "end" },
      ],
      failedJobsHeaders: [
        { text: "ID", value: "id", align: "start" },
        { text: "Job", value: "job", align: "start" },
        { text: "Falhou em", value: "failed_at", align: "start" },
        { text: "Exception", value: "exception", align: "start" },
        { text: "Ações", value: "actions", align: "end" },
      ],
    };
  },

  mounted() {
    this.selectJobs();
    this.selectFailedJobs();
  },

  methods: {
    selectJobs(page) {
      this.$http
        .index("admin/jobs", { page: page })
        .then((response) => {
          this.jobsReport = response.report;
        })
        .catch((error) => {
          console.error("Error fetching jobs data:", error);
        });
    },

    selectFailedJobs(page) {
      this.$http
        .index("admin/failed-jobs", { page: page })
        .then((response) => {
          this.failedJobsReport = response.report;
        })
        .catch((error) => {
          console.error("Error fetching failed jobs data:", error);
        });
    },

    getJobName(payload) {
      if (!payload) {
        return "-";
      }

      try {
        const parsed = JSON.parse(payload);

        return parsed.displayName || parsed?.data?.commandName || parsed.job || "-";
      } catch (error) {
        return "-";
      }
    },

    formatUnixTimestamp(timestamp) {
      if (!timestamp) {
        return "-";
      }

      const date = new Date(timestamp * 1000);

      if (Number.isNaN(date.getTime())) {
        return "-";
      }

      return date.toLocaleString("pt-BR");
    },

    viewJob(title, item) {
      this.$refs.JobsViewDialog.open(title, item);
    },
  },
};
</script>

<style></style>
